import React from 'react';
import AppLayout from '@/components/AppLayout';
import SeqConsult from '@/feat-components/SeqConsult';

const SeqConsultPage = () => {
  return <AppLayout content={<SeqConsult />} />;
};

export default SeqConsultPage;
